package com.ijoin.data.repository

import com.ijoin.data.api.ChatApi
import com.ijoin.data.model.ChatMessage
import com.ijoin.data.model.ChatThread
import com.ijoin.data.model.ChatUserSummary
import kotlinx.coroutines.flow.Flow

class ChatRepository(
    private val api: ChatApi = ChatApi(),
) {
    suspend fun getChats(): Result<List<ChatThread>> = api.getChats()

    suspend fun openChatWithUser(userId: String): Result<ChatThread> = api.openChatWithUser(userId)

    suspend fun getMessages(chatId: String): Result<List<ChatMessage>> = api.getMessages(chatId)

    suspend fun sendMessage(chatId: String, content: String): Result<ChatMessage> = api.sendMessage(chatId, content)

    suspend fun searchUsers(query: String): Result<List<ChatUserSummary>> = api.searchUsers(query)

    suspend fun markThreadRead(chatId: String): Result<Unit> = api.markThreadRead(chatId)

    fun streamMessages(chatId: String): Flow<ChatMessage> = api.streamMessages(chatId)
}
